import React from "react";
import { useParams } from "react-router-dom";

const contactsData = {
  Emmanuel: {
    name: "Emmanuel",
    role: "Desarrollador Frontend",
    bio: "Apasionado por la tecnología y el desarrollo web.",
    image: "/assets/images/emmanuel.png",
  },
  Misael: {
    name: "Misael",
    role: "Diseñador Gráfico",
    bio: "Experto en diseño visual y branding.",
    image: "/assets/images/misael.png",
  },
};

const DynamicContact = () => {
  const { name } = useParams(); // Captura el nombre dinámico desde la URL
  const contact = contactsData[name]; // Busca la información del contacto en el objeto

  // Si no se encuentra el contacto, muestra un mensaje de error
  if (!contact) {
    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h1 style={{ color: "#bb9999" }}>Contacto no encontrado</h1>
        <p style={{ color: "#ff7777" }}>El contacto que estás buscando no existe.</p>
      </div>
    );
  }

  // Renderiza los datos del contacto encontrado
  return (
    <div style={{ maxWidth: "600px", margin: "2rem auto", textAlign: "center" }}>
      <h1>{contact.name}</h1>
      <h2 style={{ color: "gray", fontWeight: "normal" }}>{contact.role}</h2>
      <p style={{ fontSize: "1rem", lineHeight: "1.5rem", marginTop: "1rem" }}>
        {contact.bio}
      </p>
      <img
        src={contact.image}
        alt={`Foto de ${contact.name}`}
        style={{ marginTop: "2rem", borderRadius: "50%", width: "150px", height: "150px" }}
      />
    </div>
  );
};

export default DynamicContact;
